<template>
  <div class="app-container">
    <div class="materialList" ref="materialList" id="materialList">
      <el-empty v-if="eqList.length == 0" description="暂无数据"></el-empty>
      <el-row :gutter="50" type="flex" style="flex-wrap: wrap" v-else>
        <el-col
          :xs="24"
          :sm="12"
          :md="12"
          :lg="6"
          :xl="6"
          v-for="(i, index) in eqList"
          :key="i + index + 'a'"
        >
          <equipment-card
            :equipment="i"
            :image-prefix="imgurl"
            :purchase="i.isCloudScene == 5"
            @details="detailsHandle"
            @action="toAppoint"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import equipmentCard from "@/components/equipmentCard.vue";
import { equipList } from "@/api/request";
export default {
  name: "",
  components: {
    equipmentCard
  },
  data() {
    return {
      imgurl: process.env.VUE_APP_FILE_API,
      keywords: "",
      id: "",
      eqList: [],
    };
  },
  beforeCreate() {},
  created() {
    this.keywords = this.$route.query.keywords;
    this.id = this.$route.query.id;
    if (this.id) {
      equipList({ isGrounding: 1, status: 1, id: this.id, pageSize: 20, pageNum: 1 }).then(
        (res) => {
          const { code, msg, rows } = res || {};
          if (code == 200 && rows.length > 0) {
            this.eqList = rows;
          } else {
            this.eqList = [];
          }
          if (code !== 200) {
            this.msgError(msg);
          }
        }
      );
    } else {
      equipList({
        isGrounding: 1,
        status: 1,
        equipmentName: this.keywords,
        pageSize: 20,
        pageNum: 1,
      }).then((res) => {
        const { code, msg, rows } = res || {};
        if (code == 200 && rows.length > 0) {
          this.eqList = rows;
        } else {
          this.eqList = [];
        }
        if (code !== 200) {
          this.msgError(msg);
        }
      });
    }
  },
  watch: {
    "$route.query.keywords": {
      handler(val) {
        this.keywords = val;
        this.search(val);
      },
    },
    "$route.query.id": {
      handler(val) {
        this.id = val;
        if (val) {
          this.searchById(val);
        }
      },
    },
  },
  methods: {
    search(val) {
      this.eqList = [];
      equipList({ isGrounding: 1, status: 1, equipmentName: val, pageSize: 20, pageNum: 1 }).then(
        (res) => {
          const { code, msg, rows } = res || {};
          if (code == 200 && rows.length > 0) {
            this.eqList = rows;
          } else {
            this.eqList = [];
          }
          if (code !== 200) {
            this.msgError(msg);
          }
        }
      );
    },
    detailsHandle(i) {
      this.$router.push({
        path: "/equipDetails",
        query: { id: i.id,type: i.isCloudScene}
      });
    },
    searchById(id) {
      this.eqList = [];
      equipList({ isGrounding: 1, status: 1, id: id, pageSize: 20, pageNum: 1 }).then((res) => {
        // this.loading = false
        const { code, msg, rows } = res || {};
        if (code == 200 && rows.length > 0) {
          this.eqList = rows;
        } else {
          this.eqList = [];
        }
        if (code !== 200) {
          this.msgError(msg);
        }
      });
    },
    // 未登录时进入登录页，成功后继续打开当前设备的预约页面
    toAppoint(i) {
      const appointRoute = this.$router.resolve({
        path: "/appointPage",
        query: {
          id: i.id,
          type: this.$route.query.type ? this.$route.query.type : 0,
        },
      }).route.fullPath;
      if(this.$store.getters.token) {
        this.$router.push(appointRoute);
        return;
      }
      this.$router.push({
        path: "/login",
        query: {
          redirect: appointRoute,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.materialList {
  width: 80%;
  margin: 50px auto;
  min-height: 575px;
}
</style>
